<template>
  <div>

    <loader v-if="!isLoaded"></loader>

    <div class="row top-button form-group-button">
      <div class="col-md-12 mt-2">
        <router-link class="btn btn-light btn-sm back mr-2"
                     :to="{name: 'quiz', params: {clientId: clientId }}">
          <i class="material-icons mdc-button__icon">arrow_back</i>
          <span>{{'quiz.backToQuizList' | trans}}</span>
        </router-link>
        <button
            v-if="quizId && !show"
            type="submit"
            class="btn btn-primary btn-sm mb-2"
            :disabled="disableAfterSubmit"
            @click.prevent="editQuiz(false)">
          {{'buttons.save' | trans}}
        </button>
        <button v-if="!quizId && !show"
                type="submit"
                class="btn btn-primary btn-sm mb-2"
                :disabled="disableAfterSubmit"
                @click.prevent="createQuiz(false)">
          {{'quiz.saveQuiz' | trans}}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9">
        <!-----title----->
        <!----select level 1 ----->
        <div class="form-group row">
          <div class="col-md-6">
            <v-select v-model="quizType"
                      :class="{'is-invalid': errors.has('field'), 'is-clear': !quizType}"
                      :options="quizList"
                      label="title"
                      name="quizType"
                      :filterable="false"
                      :disabled="!!quizId || show"
                      data-vv-validate-on="none">
            </v-select>
            <label class="mdc-floating-label">{{show ? 'quiz.typeQuiz' : 'quiz.chooseQuiz' | trans}}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="client">
      <div class="col-md-9">
        <div class="form-group row">
          <div class="col-md-6">
            <mdc-textfield id="client"
                           ref="client"
                           :label="'user.client' | trans"
                           type="text"
                           name="client"
                           class="required"
                           :class="{'is-invalid': errors.has('client')}"
                           v-validate="'required|max:255'"
                           v-model="client.code"
                           disabled/>

            <span class="invalid-feedback" v-if="errors.has('client')">
                            <strong>{{ errors.first('client') }}</strong>
                        </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9">
        <!-----title----->
        <!----select level 1 ----->


        <div class="form-group row" v-if="!show">
          <div class="col-12">
              <label class="">
                   {{'quiz.dateAndTime' | trans }}
              </label>
          </div>
          <div class="col-md-3">
            <div class="datepicker">


              <v-date-picker
                  v-model='rangeDateSheduled'
                  name="rangeDateSheduled"
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  v-validate="'required'"
                  data-vv-validate-on="none"
                  :class="{'is-invalid': errors.has('rangeDateSheduled')}"
                  :min-date="minDateStart">
              </v-date-picker>
              <span class="invalid-feedback" v-if="errors.has('rangeDateSheduled')">
                  <strong>{{ errors.first('rangeDateSheduled') }}</strong>
              </span>

              <mdc-icon icon="date_range"></mdc-icon>

            </div>


          </div>

          <div class="col-md-3 time-picker-wrapp">
            <vue-timepicker v-validate="'required'" format="HH:mm" v-model='rangeTimeStart' :hour-range="[hourRange]" :minute-range="[minuteRange]" hide-clear-button></vue-timepicker>
          </div>


        </div>

        <div class="row"  v-if="show">
          <div class="col-md-12">

            <dl class="text-secondary">

              <dt>
                {{'quiz.dateAndTime' | trans }}
              </dt>
              <dd v-if="rangeDateSheduled">
                {{rangeDateSheduled | toLocaleDate}} {{rangeTimeStart.HH}}:{{rangeTimeStart.mm}}
              </dd>

            </dl>

          </div>
        </div>


        <div class="form-group row">
          <div class="col-md-6 multiselect-wrapp required">
            <v-select id="specialists"
                      name="specialists"
                      label="id"
                      :options="specialists"
                      :filterable="false"
                      :onSearch="onSearchSpecialists"
                      :on-change="onChangeSpecialists"
                      class="aut-dropdown"
                      :class="{'is-invalid': errors.has('specialists'), 'is-clear': !specialist}"
                      v-model="specialist"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      data-vv-name="specialists"
                      :data-vv-as="'quiz.chooseSpecialist' | trans"
                      :disabled="show"
                      >
              <template slot="no-options">
                <div @mousedown.stop="">
                  {{ 'quiz.enterNameSpesialist'  | trans  }}
                </div>
              </template>
              <template slot="option" slot-scope="option">
                {{ option.displayName }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.displayName }}
              </template>
            </v-select>

            <label class="mdc-floating-label"
                   :class="{ 'invalid-feedback-label': errors.has('specialists') }">
              {{(quizId && !show) ? 'quiz.chooseSpecialist' : 'protocol.editor' | trans }}</label>
            <span class="description-row" :class="{'invalid-feedback-label' : errors.has('specialists')}" v-if="!show">{{'quiz.enterNameSpesialist' | trans }}</span>

          </div>
        </div>

        <div class="row">

          <div class="tasks col-md-12" id="tasks" v-if="assignToClientList">

            <div v-for="(client, key) in assignToClientList" :key="key" class="alert-secondary dragging-block">
              <div class="form-group row">
                <div class="col-md-9  pt-3 pt-md-0">
                  <mdc-textfield type="text"
                                 :ref="'client_' + key"
                                 :name="'client_' + key"
                                 :label="'quiz.assignToClient' | trans"
                                 class="required m-0"
                                 :class="{'is-invalid': errors.has('client_' + key)}"
                                 v-validate="'required|max:1000|unique_client'"
                                 v-model="client.name"
                                 :disabled="show"
                                 data-vv-validate-on="none"
                                 :data-vv-as="'quiz.assignToClient' | trans"/>
                  <span class="invalid-feedback"
                        v-if="errors.has('client_' + key)">
                      <strong>{{ errors.first('client_' + key) }}</strong>
                  </span>
                </div>
                <div class="col-md-3">

                  <button type="button"
                          class="btn btn-link secondary-link btn-sm float-right"
                          @click.prevent="removeAssignedToClient(client)"
                          :disabled="assignToClientList.length<2 || show">
                    {{'protocol.buttons.delete' | trans}}
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div class="col-md-12 mt-2" v-if="!show && assignToClientList.length < 5">
            <button type="button"
                    class="btn btn-info"
                    @click.prevent="addAssignToClient()">
              {{'protocol.buttons.add' | trans}}
            </button>
          </div>
        </div>


        <div class="form-group row" v-if="quizType && quizType.id == 1">
          <div class="col-md-11">
            <h4 class="row-title mt-4">{{'quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.title' | trans}}</h4>
          </div>
        </div>

        <div class="row form-group" v-if="quizType">
          <div class="col-12">

            <autocomplete-search
                class="required"
                :class="{'is-invalid': errors.has('targetBehaviour')}"
                id="targetBehaviour"
                ref="targetBehaviour"
                v-model="targetBehaviour"
                :suggestions="autocomplete"
                :visible="visible"
                :field="'name'"
                :label="'quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.questions.1' | trans"
                validateRule=""
                validateLable=""
                v-on:input="setProblemBehaviourValue"
                v-on:inputChange="onChangeProblemBehaviour"
                :multiline=true
                :disabled="show"
                rowsCount="3">
            </autocomplete-search>


          </div>
        </div>

        <div class="form-group row" v-if="quizType && quizType.id == 1">
          <div class="col-md-11 mt-4 mt-md-0">
            <mdc-textfield type="text"
                           :label="'quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.questions.2' | trans"
                           name="settingDescription"
                           :class="{'is-invalid': errors.has('settingDescription')}"
                           v-validate="'required|max:1000'"
                           class="required"
                           v-model="settingDescription"
                           data-vv-validate-on="none"
                           :disabled="show"
                           :data-vv-as="'quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.questions.2' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('settingDescription')">
                      <strong>{{ errors.first('settingDescription') }}</strong>
                  </span>

          </div>
        </div>

      </div>

      <div class="col-md-12 mt-4" v-if="quizTemplate">

        <div class="row">
          <div class="col-12" v-for="questionsRow in quizTemplate.generalQuestions">
            <h4 class="row-title mt-4">{{`quiz.question_titles.create_titles.${questionsRow.title}` | trans}}</h4>

            <div class="row mt-3" v-for="question in questionsRow.items" :key="question.id" >

              <div class="col-12" v-if="question.isDetailedAnswer && !((question.id === 1 && quizTemplate.id === 1) || (question.id === 7 && quizTemplate.id === 2))">
                <mdc-textfield :id="question.group + question.id"
                               :ref="question.group + question.id"
                               type="text"
                               :name="question.group + question.id"
                               :label="`quiz.question_titles.create_titles.${question.title}` | trans"
                               class="required"
                               :class="{'is-invalid': errors.has(question.group + question.id)}"
                               v-validate="'required|max:5000'"
                               multiline
                               rows="3"
                               v-model="question.detailedAnswer"
                               data-vv-validate-on="none"
                               :data-vv-as="`quiz.question_titles.create_titles.${question.title}` | trans"
                               :disabled="show"/>
                <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                                    </span>
              </div>

              <div class="col-12" v-if="!question.isDetailedAnswer">
                <h5 class="row-title_subsitle">{{`quiz.question_titles.create_titles.${question.title}` | trans}}</h5>
                <mdc-radio  v-for="answer in question.generalQuestionAnswers"  :disabled="show" :key="answer.id" v-model="question.answerId" :name="question.group + question.id"
                           :label="answer.title" :value="answer.id+''" data-vv-validate-on="none" />

              </div>
            </div>

          </div>
        </div>

      </div>

      <div class="col-md-12 mt-4" v-if="quizTemplate">
        <div class="row mt-2">
          <div class="col-12" v-for="(questionList, keyList) in quizTemplate.questions" :key="questionList.title">
            <h5 class="row-title" v-if="quizType.id === 2" >{{`quiz.question_titles.create_titles.${questionList.title}` | trans}}</h5>

            <table class="table table-sm" v-if="!isMobile">
              <tbody>
              <tr v-for="question in questionList.items" :key="question.id" >
                <td><span v-if="keyList !== 'evaluator_information'">{{quizType.id === 1 ? question.id : question.id-22}}.</span>
                  {{`quiz.question_titles.create_titles.${question.title}` | trans}}</td>
              </tr>
              </tbody>
            </table>

            <div v-if="isMobile">

              <div class="row" v-for="question in questionList.items" :key="question.id" >
                <div class="col-12">
                  <span v-if="keyList !== 'evaluator_information'">{{quizType.id === 1 ? question.id : question.id-22}}.</span>
                  {{`quiz.question_titles.create_titles.${question.title}` | trans}}
                </div>
              </div>
            </div>


          </div>
        </div>

      </div>

    </div>


    <div class="row top-button form-group-button">
      <div class="col-md-12 mt-2">
        <button
            v-if="quizId && !show"
            type="submit"
            class="btn btn-primary btn-sm mb-2"
            :disabled="disableAfterSubmit"
            @click.prevent="editQuiz(false)">
          {{'buttons.save' | trans}}
        </button>
        <button v-if="!quizId && !show"
                type="submit"
                class="btn btn-primary btn-sm mb-2"
                :disabled="disableAfterSubmit"
                @click.prevent="createQuiz(false)">
          {{'quiz.saveQuiz' | trans}}
        </button>
      </div>
    </div>

    <mdc-dialog v-model="isModalVisible"
                :title="'quiz.errorEdit' | trans"
                :accept="'user.close' | trans"
                @accept="onModalClose"/>



  </div>
</template>

<script>

  import axios from 'axios';
  import lang from '../../../lang/translator';
  import debounce from 'lodash/debounce';
  import map from 'lodash/map';
  import differenceBy from 'lodash/differenceBy';
  import Paginate from 'vuejs-paginate';
  import Loader from '../../loader/components/Loader';
  import TableView from '../../../common/table/components/TableView';
  import {mapGetters} from 'vuex';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import forIn from 'lodash/forIn';
  import trim from 'lodash/trim';
  import filter from 'lodash/filter';
  import uniqBy from 'lodash/uniqBy'
  import findIndex from 'lodash/findIndex'
  import VueTimepicker from 'vue2-timepicker';
  import autocompleteSearch from '../../../common/autocompleteSearch/components/autocompleteSearch';
  import {Validator} from 'vee-validate';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'client': null,
      'quizId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },

    data() {
      return {
        apiUrl: 'users/',
        quizList: [],
        quizType: null,
        quizTemplate: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        minDateStart: this.getMinDateStart(new Date()),
        specialists: [],
        specialistsIds: [],
        specialist: null,
        rangeDateSheduled: null,
        quiz: null,
        show: true,
        isLoaded: false,
        hourRange: [0, 23],
        minuteRange: [0, 60],
        rangeTimeStart: {
          HH:null,
          mm: null
        },
        autocomplete: [],
        visible: true,
        targetBehaviour: null,
        isModalVisible: false,
        disableAfterSubmit: false,
        assignToClientList: [{
          "id": null,
          "name": ""
        }],
        assignedToClient: null,
        motivation:null,
        checkFowOwn: false,
        settingDescription: null
      };
    },

    components: {
      Loader, VueTimepicker, autocompleteSearch
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapGetters('auth', [
        'user',
      ]),

    },

    mounted: function() {

    },


    provide () {
      return { parentValidator: this.$validator }
    },

    created() {
      this.show = this.$route.name === 'quiz-show';
      this.getQuizInfo();
      Validator.extend('unique_client', {
        getMessage: attribute => lang.get('validation.unique_client',{attribute}),
        validate: async (client) => {
          let valid;
          let unique = 0;

            forIn(this.assignToClientList, function(item) {
              if (trim(item.name) === trim(client)) {
                unique++;
              }
            });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });
    },

    methods: {

      onChangeSpecialists(val) {
        this.specialist = val;
      },

      addAssignToClient(item){

        this.assignedToClient = null;
        this.assignToClientList.push({
          "id": null,
          "name": ""
        });


      },

      removeAssignedToClient(client){
        let clientIndex = findIndex(this.assignToClientList,
            function(item) {
              return item.name === client.name;
            });

        if (clientIndex !== -1) {
          this.assignToClientList.splice(clientIndex, 1);
        }

      },

      onModalClose(){
        this.$router.push({name: 'quiz', params: {clientId: this.clientId }});
      },

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
      },

      async onSearchSpecialists(search, loading) {
        loading(true);
        await this.searchSpecialists(search, this);
        this.searchText = search;
        loading(false);
      },


      searchSpecialists: debounce(
          async(search, vm) => {
            try {
              let response = await axios.get(`${vm.apiUrl}${vm.clientId}/specialists/quiz/?search=${search}`);

              let specialistList = response.data.data;
              specialistList.unshift(vm.user);

              vm.specialists = differenceBy(specialistList, vm.specialist, 'id');

            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          350,
      ),

      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
            date.getDate());
        return minDateStart;
      },

      getQuizInfo: async function(){

        await this.getQuizList();
        if(this.quizId) {
          await this.getQuiz().then(async response => {

            this.quiz = response.data.data;

            this.quizType = this.quiz.quiz;
            this.specialist = this.quiz.specialist;
            this.assignToClientList = this.quiz.assignedUnits;
            this.targetBehaviour = this.quiz.description;
            this.settingDescription = this.quiz.settingDescription;


            this.rangeDateSheduled = moment(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD')._d;
            this.rangeTimeStart ={
              HH:  moment(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD HH:mm:ss').format('HH'),
              mm:  moment(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD HH:mm:ss').format('mm'),
            }

          }).finally(() => {
            this.isLoaded = true;
          });
        } else{
          this.quizType = this.quizList[0];
          this.rangeDateSheduled = new Date();
          this.rangeTimeStart = {
            HH: moment(new Date()).format('HH'),
            mm: moment(new Date()).format('mm')
          };
          this.isLoaded = true;
        }

        await this.getQuizTemplate(this.quizType.id).finally(() => {
          this.isLoaded = true;
        });


      },


      getQuizList: async function(){
        try {

          let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/`);

          this.quizList = response.data.data.items;

          return response;

        } catch (error) {
          console.dir(error);
          //this.$router.push({name: 'default'});
        }
      },



      getQuizTemplate: async function(id){

        let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/${id}`);

        let quizTemplate = response.data.data;

        forEach(quizTemplate.generalQuestions, question => {

          forEach(question.items, item => {

            if(this.quizId) {
              let detailAnswer = filter(this.quiz.quizCreatorGeneralAnswers, quizQuestion => {
                return quizQuestion.generalQuestion.id === item.id;
              });

              if(item.isDetailedAnswer){
                if((+item.id === 1 && +this.quizType.id === 1) || (+item.id === 7 && +this.quizType.id === 2)){
                  this.targetBehaviour = detailAnswer[0].detailedAnswer.toString();
                }

                item.detailedAnswer = detailAnswer[0].detailedAnswer.toString();
              } else{
                item.answerId = detailAnswer[0].generalAnswer.id.toString()
              }

            } else{
              item.detailedAnswer = null;
              item.answerId = item.generalQuestionAnswers.length ? item.generalQuestionAnswers[0].id.toString() : null;
            }

            item.questionId = item.id;

          });

        });

        this.quizTemplate = quizTemplate;

        return response;


      },

      getQuiz: async function(){

        this.isLoaded = false;

        let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/assigned/${this.quizId}`);

        return response;

      },

      editQuiz: async function(){

        this.errors.clear();

        let result = await this.$validator.validateAll();

        if(!this.targetBehaviour){
          this.errors.items.push({
            "field": "targetBehaviour",
            "msg": lang.get("quiz.errorTargetValue"),
            "rule": "required",
            "scope": null
          });
        }

        if (result && this.targetBehaviour) {

          try {

            this.disableAfterSubmit = true;

            let quizDate = new Date(
                Date.UTC(this.rangeDateSheduled.getFullYear(),
                    this.rangeDateSheduled.getMonth(),
                    this.rangeDateSheduled.getDate(),
                    this.rangeTimeStart.HH,
                    this.rangeTimeStart.mm));

            let response = await axios.put(
                `${this.apiUrl}${this.clientId}/quiz/${this.quizType.id}/assign/${this.quizId}`,
                {
                  "assignedUnits" : this.assignToClientList,
                  "assignedSpecialistId": this.specialist.id,
                  "utcScheduledAt": moment(quizDate).unix(),
                  "targetBehavior": this.targetBehaviour,
                  "settingDescription": this.settingDescription
                });



            if (response) {
              this.$router.push(
                  {name: 'quiz', params: {clientId: this.clientId}});
            }

          } catch (e) {

            if(e && e.data.code === 403){
              this.isModalVisible = true;
            }

          }
        }
      },

      createQuiz: async function(){

        this.errors.clear();

        let result = await this.$validator.validateAll();

        if(!this.targetBehaviour){
          this.errors.items.push({
            "field": "targetBehaviour",
            "msg": lang.get("quiz.errorTargetValue"),
            "rule": "required",
            "scope": null
          });
        }

        if (result && this.targetBehaviour) {
          try {

            this.disableAfterSubmit = true;

             let quizDate = new Date(
                Date.UTC(this.rangeDateSheduled.getFullYear(),
                    this.rangeDateSheduled.getMonth(),
                    this.rangeDateSheduled.getDate(),
                    this.rangeTimeStart.HH,
                    this.rangeTimeStart.mm));

            let response = await axios.post(
                `${this.apiUrl}${this.clientId}/quiz/${this.quizType.id}/assign`,
                {
                  "assignedUnits" : this.assignToClientList,
                  "assignedSpecialistId": this.specialist.id,
                  "utcScheduledAt": moment(quizDate).unix(),
                  "targetBehavior": this.targetBehaviour,
                  "settingDescription": this.settingDescription
                });

            if (response) {
              this.$router.push(
                  {name: 'quiz', params: {clientId: this.clientId}});
            }

          } catch (e) {

          }
        }
      },

      searchAutocomplete: debounce(
          async (search, vm) => {
            try {

              let response = await axios.get(vm.apiUrl + vm.clientId + '/quiz/target-behavior/search' +
                  '?search=' + search, {params: {
                  quizId: vm.quiz && vm.quiz.id ? vm.quiz.id : null
                }
              });
              vm.autocomplete = uniqBy(response.data.data, 'name');

            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          250,
      ),

      setProblemBehaviourValue(value) {
        this.targetBehaviour = value;

      },


      onChangeProblemBehaviour(search) {
        this.searchAutocomplete(search, this);
      },

      setProblemBehaviourValidated(text) {
        console.info(text)
        this.targetBehaviour = text;
        this.autocomplete = [];
      },

      validatedProblemBehaviour(error) {
        this.errors.items.push(error.items[0]);
      },


    },
    watch: {
      async quizType(newVlaue, oldValue){
        if(oldValue){
          this.isLoaded = false;
          await this.getQuizTemplate(newVlaue.id);
          this.isLoaded = true;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/quiz/components/Quiz.vue